import { render } from "./Invoice.vue?vue&type=template&id=27afab0c&scoped=true&ts=true"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=27afab0c&scoped=true&lang=stylus"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27afab0c"]])

export default __exports__